import * as Types from '@flowwai-frontend/bps-officer-web/graphql'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'
export type RevokeGoogleUserAuthorizationResultMutationVariables = Types.Exact<{
   [key: string]: never
}>

export type RevokeGoogleUserAuthorizationResultMutation = {
   __typename?: 'Mutation'
   revokeGoogleAuthorization:
      | { __typename?: 'GoogleAuthConsentNotGiven'; message?: string | null }
      | {
           __typename?: 'RevokeGoogleUserAuthorizationResult'
           isRevoked: boolean
        }
}

export const RevokeGoogleUserAuthorizationResultDocument = gql`
   mutation RevokeGoogleUserAuthorizationResult {
      revokeGoogleAuthorization {
         ... on RevokeGoogleUserAuthorizationResult {
            isRevoked
         }
         ... on GoogleAuthConsentNotGiven {
            message
         }
      }
   }
`
export type RevokeGoogleUserAuthorizationResultMutationFn = Apollo.MutationFunction<
   RevokeGoogleUserAuthorizationResultMutation,
   RevokeGoogleUserAuthorizationResultMutationVariables
>
export type RevokeGoogleUserAuthorizationResultMutationResult = Apollo.MutationResult<
   RevokeGoogleUserAuthorizationResultMutation
>
export type RevokeGoogleUserAuthorizationResultMutationOptions = Apollo.BaseMutationOptions<
   RevokeGoogleUserAuthorizationResultMutation,
   RevokeGoogleUserAuthorizationResultMutationVariables
>
